import React from "react";
import { QuestionItem } from "../../../types/form";

interface EmailFieldRendererProps {
  question: QuestionItem;
  inputName: string;
  currentValue: unknown;
  setFormData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  readOnly?: boolean;
}

const EmailFieldRenderer: React.FC<EmailFieldRendererProps> = ({
  question,
  inputName,
  currentValue,
  setFormData,
  readOnly = false,
}) => {
  const display =
    currentValue === null || currentValue === undefined
      ? ""
      : String(currentValue);

  return (
    <div className="space-y-1">
      <input
        type="email"
        name={inputName}
        id={inputName}
        inputMode="email"
        autoComplete="email"
        className="border p-2 rounded-md w-full max-w-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-100"
        placeholder={question.placeholder || "name@example.com"}
        value={display}
        disabled={readOnly}
        aria-describedby={`${inputName}-email-hint`}
        onChange={(e) => {
          setFormData((prev) => ({
            ...prev,
            [inputName]: e.target.value,
          }));
        }}
      />
      <p id={`${inputName}-email-hint`} className="text-xs text-gray-500">
        Saved in lowercase when valid
      </p>
    </div>
  );
};

export default EmailFieldRenderer;
